import { createContext, useContext, useState, ReactNode } from "react";
import { AvailabilitiesType } from "data/types";

// Define the context type
interface ListingBookingProviderType {
  availabilitiesState: AvailabilitiesType;
  setAvailibitiesState: React.Dispatch<React.SetStateAction<AvailabilitiesType>>;
  propertyID:string
  setPropertyID: React.Dispatch<React.SetStateAction<string>>;
}

// Create context with the proper type
const ListingBookingContext = createContext<ListingBookingProviderType | undefined>(undefined);

export const useListingBooking = () => {
  const context = useContext(ListingBookingContext);
  if (!context) {
    throw new Error("useBooking must be used within a ListingBookingProvider");
  }
  return context;
};

interface BookingProviderProps {
  children: ReactNode;
}

export const ListingBookingProvider: React.FC<BookingProviderProps> = ({ children }) => {
  const [availabilitiesState, setAvailibitiesState] = useState<AvailabilitiesType>({ 
    isLoaded: false,
    availabilities: ["not available"]
  });
  const [propertyID, setPropertyID] = useState("");

  return (
    <ListingBookingContext.Provider value={{ 
      availabilitiesState, 
      setAvailibitiesState,
      propertyID,
      setPropertyID }}>
      {children}
    </ListingBookingContext.Provider>
  );
};